/**
 * <sunday-spill>: the protector's spill demo. Tapping the button restarts the CSS animation
 * (cup tips, drops fall, a puddle forms; on the bare side it soaks in) and swaps the words.
 */
class SundaySpill extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.stage = this.querySelector('[data-stage]');
    this.btn = this.querySelector('[data-spill]');
    this.say = this.querySelector('[data-say]');
    this.btn.addEventListener('click', () => {
      this.stage.classList.remove('sd-go');
      void this.stage.getBoundingClientRect(); // restart the animation
      this.stage.classList.add('sd-go');
      if (this.dataset.again) this.btn.textContent = this.dataset.again;
      if (this.dataset.after) this.say.textContent = this.dataset.after;
    });
  }
}
if (!customElements.get('sunday-spill')) customElements.define('sunday-spill', SundaySpill);
